import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/app/ui/assets/svg/plus-circle-red.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-57343a5c")

_pushScopeId("data-v-57343a5c")
const _hoisted_1 = { id: "section-upload-photo" }
const _hoisted_2 = { class: "text-sm font-normal text-red-lp-100 label-accordion flex flex-row pt-2" }
const _hoisted_3 = { class: "font-semibold" }
const _hoisted_4 = { class: "bg-red-lp-50 p-4" }
const _hoisted_5 = { class: "flex flex-row mt-4 w-full gap-x-2" }
const _hoisted_6 = {
  class: "flex flex-row gap-x-4",
  style: {"width":"380px"}
}
const _hoisted_7 = {
  class: "relative flex flex-col my-2 items-center justify-center",
  style: {"width":"120px"}
}
const _hoisted_8 = { class: "text-10px xxl:text-11px font-montserrat font-normal text-center my-2" }
const _hoisted_9 = {
  class: "text-12px border-r pr-4",
  style: {"border-color":"#eabcbe"}
}
const _hoisted_10 = { class: "font-semibold font-montserrat text-gray-lp-300" }
const _hoisted_11 = { class: "list-disc pl-5" }
const _hoisted_12 = { class: "font-normal xxl:text-13px mt-2" }
const _hoisted_13 = { class: "font-normal xxl:text-13px w-" }
const _hoisted_14 = { class: "font-normal xxl:text-13px" }
const _hoisted_15 = { class: "font-normal xxl:text-13px" }
const _hoisted_16 = { class: "pl-4 flex flex-row items-center overflow-y-auto" }
const _hoisted_17 = { class: "flex flex-row gap-4 mb-3" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_card = _resolveComponent("card")!
  const _component_UploadImageTiny = _resolveComponent("UploadImageTiny")!
  const _component_Accordion = _resolveComponent("Accordion")!
  const _directive_sanitize_html = _resolveDirective("sanitize-html")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_Accordion, {
      onUpdate: _ctx.onClick,
      ref: "accordion-adjustment",
      modelValue: _ctx.showViewAdjustment,
      bgColor: "bg-red-lp-50",
      borderHeader: "border-b",
      mainBorderEdge: "",
      borderBody: "border-none",
      defaultOpened: _ctx.defaultOpened,
      label: _ctx.title,
      chevrons: ['chevron-up-red', 'chevron-down-red'],
      class: 
        `text-12px xxl:text-14px ${_ctx.marginBottom ? 'mb-5' : ''} ${
          _ctx.isShaking ? 'animate-shaking alerts-border' : 'border-none'
        } rounded-md`
      ,
      customLabel: "",
      customWidthHeader: "w-19/20"
    }, {
      "custom-label": _withId(() => [
        _createVNode("div", _hoisted_2, [
          _createTextVNode(_toDisplayString(_ctx.$t('outgoingShipment.bagging.uploadPhoto.headerLeading')) + " ", 1),
          _createVNode("div", _hoisted_3, "  " + _toDisplayString(_ctx.$t('outgoingShipment.bagging.uploadPhoto.headerTrailing')), 1)
        ])
      ]),
      default: _withId(() => [
        _createVNode("div", _hoisted_4, [
          _createVNode("div", _hoisted_5, [
            _createVNode("div", _hoisted_6, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.photoGuides, (key) => {
                return (_openBlock(), _createBlock(_component_card, {
                  class: "px-2",
                  key: key
                }, {
                  default: _withId(() => [
                    _createVNode("div", _hoisted_7, [
                      _createVNode("img", {
                        src: require(`@/app/ui/assets/svg/${key.source}.svg`),
                        class: "h-28 w-28 object-cover rounded",
                        alt: "result-image"
                      }, null, 8, ["src"])
                    ]),
                    _withDirectives(_createVNode("p", _hoisted_8, null, 512), [
                      [_directive_sanitize_html, _ctx.$t(key.desc)]
                    ])
                  ]),
                  _: 2
                }, 1024))
              }), 128)),
              _createVNode("div", _hoisted_9, [
                _createVNode("p", _hoisted_10, _toDisplayString(_ctx.$t('outgoingShipment.bagging.uploadPhoto.rulesTitle')), 1),
                _createVNode("ul", _hoisted_11, [
                  _createVNode("li", _hoisted_12, _toDisplayString(_ctx.$t('outgoingShipment.bagging.uploadPhoto.ruleGoodResolution')), 1),
                  _createVNode("li", _hoisted_13, _toDisplayString(_ctx.$t('outgoingShipment.bagging.uploadPhoto.ruleScaleReadable')), 1),
                  _createVNode("li", _hoisted_14, _toDisplayString(_ctx.$t('outgoingShipment.bagging.uploadPhoto.ruleAllPackagesVisible')), 1),
                  _createVNode("li", _hoisted_15, _toDisplayString(_ctx.$t('outgoingShipment.bagging.uploadPhoto.ruleMinimumOne')), 1)
                ])
              ])
            ]),
            _createVNode("div", _hoisted_16, [
              _createVNode("div", _hoisted_17, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.proofPhotos, (photo, index) => {
                  return (_openBlock(), _createBlock("div", { key: index }, [
                    _createVNode(_component_UploadImageTiny, {
                      accept: "image/png, image/jpg, image/jpeg",
                      widthContentCard: _ctx.proofPhotos.length > 2 ? 'w-24' : '',
                      titleSize: "10",
                      onUpload: _ctx.onUpload,
                      onRemove: _ctx.onRemove,
                      title: photo?.desc,
                      modelValue: _ctx.attachmentImage[index],
                      "onUpdate:modelValue": ($event: any) => (_ctx.attachmentImage[index] = $event),
                      defaultImage: _ctx.generateDefaultImage(index),
                      maxSize: 5,
                      watermark: _ctx.watermark,
                      multipleIndex: index,
                      disabled: _ctx.getRulePieceDisabled,
                      customWatermark: _ctx.customWatermark
                    }, null, 8, ["widthContentCard", "onUpload", "onRemove", "title", "modelValue", "onUpdate:modelValue", "defaultImage", "watermark", "multipleIndex", "disabled", "customWatermark"])
                  ]))
                }), 128))
              ]),
              (_ctx.proofPhotos.length < _ctx.maxPhoto)
                ? (_openBlock(), _createBlock("img", {
                    key: 0,
                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onAddImage && _ctx.onAddImage(...args))),
                    src: _imports_0,
                    alt: "plus-circle-red",
                    class: "w-5 h-5 ml-4 cursor-pointer"
                  }))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["onUpdate", "modelValue", "defaultOpened", "label", "class"])
  ]))
})